import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import get from 'lodash-es/get';
import { Subject } from 'rxjs';

import { Location } from '@finder/features/calendars/calendars.interface';
import { CalendarsService } from '../../services/calendar.service';

@Component({
    selector: 'finder-calendar-five-day',
    templateUrl: './five-day.component.html',
    styleUrls: ['./five-day.component.scss']
})
export class CalendarFiveDayComponent implements OnInit, OnDestroy{

    data: any;
    locations: Array<Location>;

    private destroy$ = new Subject<void>();

    constructor(
        private route: ActivatedRoute,
        private calendarService: CalendarsService
    ) { }

    ngOnInit() {
        this.data = get(this.route.snapshot.parent.data, 'calendar');
        this.calendarService.watchLocations()
            .pipe(takeUntil(this.destroy$))
            .subscribe(locations => {
                this.locations = locations;
            });
    }

    ngOnDestroy() {
        // Ignore the if just for coverage, there's no need to test unsubscribe
        this.destroy$.next();
        this.destroy$.complete();
    }
}
